import { LogoutOptions, RedirectLoginOptions } from '@auth0/auth0-angular';

import { UserResponse } from '@smarthead-api/models/user-response';

export class LoginWithRedirect {
  static readonly type = '[app] auth0 loginWithRedirect';
  constructor(public options?: RedirectLoginOptions<any>) {}
}

export class UserLogIn {
  static readonly type = '[app] user is logged in';
  constructor(
    public accessToken: string,
    public expiresIn: number,
    public idToken: string,
    public idTokenPayload: any
  ) {}
}

export class StartLoadingUserData {
  static readonly type = '[app] user data are about to load';
  constructor() {}
}

export class UserDataLoaded {
  static readonly type = '[app] user data are loaded';
  constructor(public userData: UserResponse) {}
}

export class UserLogOut {
  static readonly type = '[app] user log out';
  constructor(public options?: LogoutOptions) {}
}
